import { fetchTranslation, CmsRequestType } from '../cms';
import { AbstractCachableStore } from './abstract-cachable-store';
export class AbstractI18nStore extends AbstractCachableStore {
    constructor(logger, request, cache) {
        super(logger, cache);
        this.request = request;
    }
    async init(callback) {
        try {
            await super.init(callback);
        }
        catch (error) {
            this.logger.error('Failed to fetch translations: ', error);
        }
    }
    fetchData() {
        return fetchTranslation(this.request);
    }
    get cacheKey() {
        return [CmsRequestType.TRANSLATION.toLocaleUpperCase(), this.request.scope].join(':');
    }
    translate(key, values) {
        if (!this.data) {
            return '';
        }
        const expression = this.data[key];
        if (expression) {
            if (typeof values === 'undefined') {
                return expression;
            }
            return Object.keys(values).reduce((result, param) => result.split(new RegExp(`{{${param}}}`, 'i')).join(values[param]), expression);
        }
        if (typeof values === 'undefined') {
            return key;
        }
        return `${key} ${JSON.stringify(values)}`;
    }
}
//# sourceMappingURL=abstract-i18n.js.map